"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3918],{

/***/ 3918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_SiteLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/index.js + 1 modules
var Footer = __webpack_require__(9458);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Container.js
var Container = __webpack_require__(38661);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Main.js
var Main = __webpack_require__(78682);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Nav.js
var Nav = __webpack_require__(53512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Sidebar.js
var Sidebar = __webpack_require__(58287);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Copyright.js
var Copyright = __webpack_require__(7212);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Logo.js
var Logo = __webpack_require__(33768);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Social.js
var Social = __webpack_require__(72025);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
// EXTERNAL MODULE: ./src/prerendered-logo.js
var prerendered_logo = __webpack_require__(25476);
;// CONCATENATED MODULE: ./src/SiteFooter/index.js















const SiteFooter = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("footer");
    const year = (0,react.useMemo)(()=>new Date().getFullYear(), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Main/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavRow */.z4, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("PRODUCT")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "features-F",
                                                        href: "/features",
                                                        children: t("FEATURES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "snapgene-viewer-F",
                                                        href: "/snapgene-viewer",
                                                        children: t("VIEWER")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "convert-file-formats-F",
                                                        href: "/features/convert-file-formats",
                                                        children: t("CONVERT_FILE_FORMATS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "release-notes-F",
                                                        href: "/updates",
                                                        children: t("RELEASE_NOTES")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("GET_PRODUCT")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "free-trial-F",
                                                        href: "/free-trial",
                                                        children: t("FREE_TRIAL")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "pricing-F",
                                                        href: "/pricing",
                                                        children: t("PRICING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "course-licenses-F",
                                                        href: "/free-course-license",
                                                        children: t("COURSE_LICENSES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "iGEM-F",
                                                        href: "/igem",
                                                        children: t("IGEM")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("RESOURCES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "academy-F",
                                                        href: "/resources",
                                                        children: t("SNAPGENE_ACADEMY")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "product-tutorials-F",
                                                        href: "/resources",
                                                        children: t("PRODUCT_TUTORIALS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "user-guide-F",
                                                        href: "https://support.snapgene.com/hc/en-us/categories/10304176221716",
                                                        children: t("USER_GUIDE")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "common-questions-F",
                                                        href: "https://support.snapgene.com/hc/en-us/",
                                                        children: t("QUESTIONS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "CRISPR-F",
                                                        href: "/guides/design-grna-for-crispr",
                                                        children: t("CRISPR")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "plasmids-F",
                                                        href: "/plasmids",
                                                        children: t("PLASMIDS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "coronavirus_resources-F",
                                                        href: "/plasmids/coronavirus_resources",
                                                        children: t("CORONAVIRUS_RESOURCES")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("CLONING_TOOLS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "restriction-cloning-F",
                                                        href: "/guides/restriction-enzyme-cloning",
                                                        children: t("RESTRICTION_CLONING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "gateway-cloning-F",
                                                        href: "/guides/gateway-cloning",
                                                        children: t("GATEWAY_CLONING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "ta-cloning-F",
                                                        href: "/guides/gibson-assembly",
                                                        children: t("GIBSON_ASSEMBLY")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "nebuilder-hifi-F",
                                                        href: "/guides/in-fusion-cloning",
                                                        children: t("INFUSION_CLONING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "gateway-cloning-F",
                                                        href: "/guides/cloning-pcr-products",
                                                        children: t("PCR_CLONING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "topo-cloning-F",
                                                        href: "/guides/topo-cloning",
                                                        children: t("TOPO_CLONING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "golden-gate-assembly-F",
                                                        href: "/guides/golden-gate-assembly",
                                                        children: t("GOLDEN_GATE")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("COMPANY")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "about-F",
                                                        href: "/about",
                                                        children: t("ABOUT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "customers-F",
                                                        href: "/customers",
                                                        children: t("CUSTOMERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "citations-F",
                                                        href: "/guides/citations",
                                                        children: t("CITATIONS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "support-F",
                                                        href: "https://support.snapgene.com/hc/en-us/",
                                                        children: t("SUPPORT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "dotmatics-F",
                                                        href: routes/* default.external.dotmatics */.ZP.external.dotmatics,
                                                        children: t("DOTMATICS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "portfolio-F",
                                                        href: routes/* default.external.portfolio */.ZP.external.portfolio,
                                                        children: t("PORTFOLIO")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        "data-qa-selector": "careers-F",
                                                        href: routes/* default.external.careers */.ZP.external.careers,
                                                        children: t("CAREERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        "data-qa-selector": "contact-F",
                                                        href: "/contact",
                                                        children: t("CONTACT")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Copyright/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                logoPath: prerendered_logo/* logoPath */.j1,
                                logoAlt: prerendered_logo/* logoAlt */.B$
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Copyright/* FooterCopyrightText */.rQ, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Copyright/* FooterCopyrightText.CompanyName */.rQ.CompanyName, {
                                        children: [
                                            "\xa9 ",
                                            year,
                                            " ",
                                            t("COMPANY_NAME")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright/* FooterCopyrightLink */.X6, {
                                        "data-qa-selector": "privacy-policy-F",
                                        href: "/privacy-policy",
                                        spacing: {
                                            mb: 2
                                        },
                                        children: t("PRIVACY_POLICY")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright/* FooterCopyrightLink */.X6, {
                                        "data-qa-selector": "legal-disclaimers-F",
                                        href: "/legal-disclaimers",
                                        spacing: {
                                            mb: 2
                                        },
                                        children: t("LEGAL_DISCLAIMERS")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright/* FooterCopyrightLink */.X6, {
                                        "data-qa-selector": "do-not-sell-F",
                                        href: routes/* default.external.doNotSell */.ZP.external.doNotSell,
                                        spacing: {
                                            mb: 2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                            Tag: "span",
                                            children: t("DO_NOT_SELL")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Social/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Social/* FooterSocialItemLink */.F, {
                                        "data-qa-selector": "twitter-square-F",
                                        href: "https://twitter.com/snapgene/",
                                        name: "twitter-square"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Social/* FooterSocialItemLink */.F, {
                                        "data-qa-selector": "facebook-square-F",
                                        href: "https://www.facebook.com/SnapGene/",
                                        name: "facebook-square"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Social/* FooterSocialItemLink */.F, {
                                        "data-qa-selector": "linkedin-square-F",
                                        href: "https://www.linkedin.com/company/gsl-biotech/",
                                        name: "linkedin-square"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var src_SiteFooter = (SiteFooter);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/index.js + 1 modules
var Navbar = __webpack_require__(37762);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Item.js
var Item = __webpack_require__(88881);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Link.js
var Link = __webpack_require__(81453);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/Title.js
var Title = __webpack_require__(36555);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/index.js + 1 modules
var NavbarDropdown = __webpack_require__(86210);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/Menu.js
var Menu = __webpack_require__(1385);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/MenuItem.js
var MenuItem = __webpack_require__(10110);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/index.js + 1 modules
var TopBar = __webpack_require__(88311);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Logo.js
var TopBar_Logo = __webpack_require__(39755);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var atomic_react_Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Nav.js
var TopBar_Nav = __webpack_require__(65717);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Dropdown.js
var Dropdown = __webpack_require__(43223);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./src/services/auth.js + 4 modules
var auth = __webpack_require__(5803);
// EXTERNAL MODULE: ./src/utils/global-context/index.js + 1 modules
var global_context = __webpack_require__(6601);
;// CONCATENATED MODULE: ./src/hooks/useAuth.js


function useAuth() {
    const context = (0,global_context/* useGlobalContext */.b)();
    const isAuthorized = auth/* isAuthorized */.QO(context);
    return {
        isAuthorized
    };
}
/* harmony default export */ var hooks_useAuth = (useAuth);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/index.js + 1 modules
var MegaMenu = __webpack_require__(69514);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/Item.js
var MegaMenu_Item = __webpack_require__(4991);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/Grid.js
var Grid = __webpack_require__(15062);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ButtonTheme/index.js + 1 modules
var ButtonTheme = __webpack_require__(10980);
;// CONCATENATED MODULE: ./src/SiteHeader/PlatformTopBar.js











const PlatformTopBar = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu/* default */.Z, {
                utility: {
                    justify: "start"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                    md: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu_Item/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontSize: "l",
                                    fontColor: "white",
                                    fontWeight: "bold"
                                },
                                children: t("topbar.platform.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontSize: "s",
                                    fontColor: "white"
                                },
                                children: t("topbar.platform.DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTheme/* default.Link */.Z.Link, {
                                href: routes/* default.external.platform */.ZP.external.platform,
                                size: "xs",
                                spacing: {
                                    px: 5,
                                    py: 3,
                                    mt: 4
                                },
                                styleType: "topbar",
                                target: "_blank",
                                children: [
                                    t("topbar.platform.BTN"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        spacing: {
                                            ml: 4
                                        },
                                        name: "link-ext"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/images/dotmatics/lab-archives/top-bar/platform.png",
                className: "position-absolute top-0 right-0"
            })
        ]
    });
};
/* harmony default export */ var SiteHeader_PlatformTopBar = (PlatformTopBar);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/MegaMenuBlockLink.js
var MegaMenuBlockLink = __webpack_require__(80178);
;// CONCATENATED MODULE: ./src/SiteHeader/ProductsTopBar.js










const ProductsTopBar = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu/* default */.Z, {
        spacing: {
            py: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: routes/* default.external.products.prism */.ZP.external.products.prism,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Prism.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.PRISM")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: routes/* default.external.products.geneious */.ZP.external.products.geneious,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Geneious.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.GENEIOUS")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: "#",
                    onClick: (e)=>e.preventDefault(),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-SnapGene.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.SNAPGENE")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: routes/* default.external.products.labArchives */.ZP.external.products.labArchives,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-LabArchives.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.LABARCHIVES")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: routes/* default.external.products.proteinMetrics */.ZP.external.products.proteinMetrics,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Protein-Metrics.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.PROTEINMETRIC")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: routes/* default.external.products.omiq */.ZP.external.products.omiq,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-OMIQ.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.OMIQ")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: routes/* default.external.products.fcsExpress */.ZP.external.products.fcsExpress,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-FCS-Express.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.FCSEXPRESS")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: routes/* default.external.products.nQuery */.ZP.external.products.nQuery,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-nQuery.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("topbar.products.NQUERY")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                sm: 12,
                md: 12,
                lg: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTheme/* default.Link */.Z.Link, {
                        href: routes/* default.external.portfolio */.ZP.external.portfolio,
                        size: "xs",
                        spacing: {
                            px: 5,
                            py: 3,
                            mt: 4,
                            mb: 8
                        },
                        styleType: "topbar",
                        target: "_blank",
                        children: [
                            t("topbar.products.BTN"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                spacing: {
                                    ml: 4
                                },
                                name: "link-ext"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SiteHeader_ProductsTopBar = (ProductsTopBar);

;// CONCATENATED MODULE: ./src/SiteHeader/index.js



























const SiteHeader = (param)=>{
    let { hero =false , isBorderBottomNone =false  } = param;
    const [t] = (0,i18/* useLocale */.bU)("header");
    const { isAuthorized  } = hooks_useAuth();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBar/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_Logo/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Link/* default */.Z, {
                            href: routes/* default.external.dotmatics */.ZP.external.dotmatics,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/common/dotmatics-logo-white.svg"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_Nav/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                            isMegaMenu: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Title */.Z.Title, {
                                    triangle: true,
                                    triangleProps: {
                                        color: "2",
                                        isOpenColor: "2"
                                    },
                                    children: t("topbar.PLATFORM_PRODUCTS")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Body */.Z.Body, {
                                    utility: {
                                        bgColor: "dotmatics-6",
                                        border: {
                                            top: {
                                                width: 1,
                                                color: "white--20"
                                            },
                                            bottom: {
                                                width: 1,
                                                color: "white--20"
                                            }
                                        }
                                    },
                                    spacing: {
                                        my: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteHeader_PlatformTopBar, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteHeader_ProductsTopBar, {})
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                hero: hero,
                isBorderBottomNone: isBorderBottomNone,
                logo: prerendered_logo/* default */.ZP,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                    utility: {
                        lg: {
                            display: "flex",
                            justify: "end"
                        }
                    },
                    sizing: {
                        lg: {
                            w: "full"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                            nav: "primary",
                            type: 1,
                            inverted: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: Link/* default */.Z,
                                        "data-qa-selector": "features-H",
                                        href: "/features",
                                        children: t("FEATURES")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: Link/* default */.Z,
                                        "data-qa-selector": "plasmids-H",
                                        href: "/plasmids",
                                        children: t("PLASMIDS")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarDropdown/* default */.Z, {
                                    isSecondaryNav: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                            triangleProps: {
                                                color: "2",
                                                isOpenColor: "3"
                                            },
                                            children: t("RESOURCES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                            align: "right",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: MenuItem/* default.Link */.Z.Link,
                                                        "data-qa-selector": "getting-started",
                                                        href: "/series/getting-started",
                                                        children: t("GETTING_STARTED")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: MenuItem/* default.Link */.Z.Link,
                                                        "data-qa-selector": "snapgene-academy",
                                                        href: "/resources",
                                                        children: t("SNAGENE_ACADEMY")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default.Link */.Z.Link, {
                                                        "data-qa-selector": "user-guides-header",
                                                        href: "https://support.snapgene.com/hc/en-us/categories/10304176221716",
                                                        children: t("USER_GUIDES")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: Link/* default */.Z,
                                        "data-qa-selector": "support-H",
                                        href: routes/* default.external.support */.ZP.external.support,
                                        children: t("SUPPORT")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: Link/* default */.Z,
                                        "data-qa-selector": "pricing-H",
                                        href: "/pricing",
                                        children: t("HOW_TO_BUY")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                            nav: "secondary",
                            type: 1,
                            inverted: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    secondary: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
                                        Component: Link/* default */.Z,
                                        "data-qa-selector": "sign-in-H",
                                        href: isAuthorized ? routes/* default.myAccount */.ZP.myAccount : routes/* default.login */.ZP.login,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "user"
                                            }),
                                            " ",
                                            t(isAuthorized ? "MY_ACCOUNT" : "SIGNIN")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    secondary: true,
                                    className: "secondary-nav__item-trial",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
                                        Component: Button/* default.Link */.Z.Link,
                                        "data-qa-selector": "free-trial-H",
                                        size: "s",
                                        href: "/free-trial",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "arrow-to-bottom"
                                            }),
                                            " Free Trial"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
SiteHeader.propTypes = {
    hero: prop_types.bool,
    isBorderBottomNone: prop_types.bool
};
/* harmony default export */ var src_SiteHeader = (SiteHeader);

;// CONCATENATED MODULE: ./src/SiteLayout/index.js






const SiteLayout = (param)=>{
    let { bodyClassName ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_SiteHeader, {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Body */.Z.Body, {
                className: bodyClassName,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Footer */.Z.Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_SiteFooter, {})
            })
        ]
    });
};
SiteLayout.propTypes = {
    bodyClassName: prop_types.string,
    children: prop_types.node,
    hero: prop_types.bool
};
/* harmony default export */ var src_SiteLayout = (SiteLayout);


/***/ })

}]);